import { isNil, isEmpty, filter, isString, isArray, partition, sortBy, isObject, concat, cloneDeep } from 'lodash';

export function initHelper(dataWrapper, collectionKey) {
  if (isNil(dataWrapper[collectionKey])) dataWrapper[collectionKey] = [];
  dataWrapper[collectionKey].all = function (id) {
    try {
      return filter(dataWrapper[collectionKey], (it) => {
        if (it.deleted === true) {
          if (isString(id)) return it.id === id;
          else if (isArray(id)) return id.includes(it.id);
          else return false;
        } else {
          return true;
        }
      });
    } catch (e) {
      return dataWrapper[collectionKey];
    }
  };
}

export function sortHelper(dataWrapper, collectionKey, primaryLanguage = 'de', additionalSorts = [], preSorts = []) {
  const collection = dataWrapper[collectionKey];

  if (isNil(collection)) {
    dataWrapper[collectionKey] = collection;
    return;
  }

  if (!isArray(collection)) {
    dataWrapper[collectionKey] = collection;
    return;
  }

  const partitionedCollection = partition(collection, { deleted: true });

  partitionedCollection[0].forEach((it) => {
    if (isString(it.name)) {
      it.name = `[${it.name}]`;
    } else {
      Object.keys(it.name).forEach((lang) => { it.name[lang] = `[${it.name[lang]}]`; });
    }
  });

  partitionedCollection[0] = sortBy(partitionedCollection[0], 'lastModified');

  partitionedCollection[1] = sortBy(partitionedCollection[1], [...preSorts, 'sort', ...additionalSorts], (it) => {
    if (isNil(it)) return null;
    else if (isString(it.name) || isEmpty(it.name)) return it.name;
    else if (isObject(it.name)) return it.name[primaryLanguage];
    else return it.name;
  });

  dataWrapper[collectionKey] = concat(partitionedCollection[1], partitionedCollection[0]);

  initHelper(dataWrapper, collectionKey);
}

export function optimizeInputData(inputData) {
  try {
    try {
      inputData.roomTypes.map((it) => {
        if (isEmpty(it.abbreviation) && !isEmpty(it.name) && !isEmpty(it.name[inputData.details.primaryLanguage]) && !it.deleted) {
          it.abbreviation = it.name[inputData.details.primaryLanguage].toUpperCase().replace(/[^A-Z0-9]/gi, '').replace(/(?!^)[AEIOU](?!$)/g, '').substr(0, 4);
        }
        return it;
      });
      inputData.rooms.map((it) => {
        if (!isEmpty(it.roomType) && !it.deleted) {
          const rt = it.roomType;
          if (isEmpty(rt.abbreviation) && !isEmpty(rt.name) && !isEmpty(rt.name[inputData.details.primaryLanguage]) && !rt.deleted) {
            rt.abbreviation = rt.name[inputData.details.primaryLanguage].toUpperCase().replace(/[^A-Z0-9]/gi, '').replace(/(?!^)[AEIOU](?!$)/g, '').substr(0, 4);
          }
        }
        return it;
      });
      inputData.ratePlans.forEach((it) => {
        if (isNil(it.plainName)) {
          it.plainName = cloneDeep(it.name);
          if (!it.deleted && !isNil(it.internalName)) {
            Object.keys(it.name)
              .forEach((lang) => {
                if (!isEmpty(it.internalName[lang])) {
                  it.name[lang] = `${it.name[lang]} [${it.internalName[lang]}]`;
                }
              });
          }
        }
      });
    } catch (ignore) { /* ignore */ }

    // eslint-disable-next-line no-console
    try { initHelper(inputData, 'rooms'); } catch (e) { console.error('Failed to sort rooms'); }
    // eslint-disable-next-line no-console
    try { initHelper(inputData, 'policies'); } catch (e) { console.error('Failed to sort policies'); }
    // eslint-disable-next-line no-console
    try { initHelper(inputData, 'guestCategories'); } catch (e) { console.error('Failed to sort guestCategories'); }
    // eslint-disable-next-line no-console
    try { sortHelper(inputData, 'ratePlans', inputData.details.primaryLanguage, ['type'], [it => (it.ratePlanType === 'DayRate' && it.hideInternally ? 1 : -1)]); } catch (e) { console.error('Failed to sort ratePlans'); }
    // eslint-disable-next-line no-console
    try { sortHelper(inputData, 'roomTypes', inputData.details.primaryLanguage); } catch (e) { console.error('Failed to sort roomTypes'); }
    // eslint-disable-next-line no-console
    try { sortHelper(inputData, 'seasons', inputData.details.primaryLanguage); } catch (e) { console.error('Failed to sort seasons'); }
    // eslint-disable-next-line no-console
    try { sortHelper(inputData, 'inHouseServices', inputData.details.primaryLanguage); } catch (e) { console.error('Failed to sort inHouseServices'); }
    // eslint-disable-next-line no-console
    try { sortHelper(inputData, 'taxes', inputData.details.primaryLanguage); } catch (e) { console.error('Failed to sort taxes'); }
    // eslint-disable-next-line no-console
    try { sortHelper(inputData, 'ageCategories', inputData.details.primaryLanguage, ['ageFrom']); } catch (e) { console.error('Failed to sort ageCategories'); }
    // eslint-disable-next-line no-console
    try { sortHelper(inputData, 'mealPlans', inputData.details.primaryLanguage); } catch (e) { console.error('Failed to sort mealPlans'); }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Failed to sort hotel data.', e);
  }
}



// WEBPACK FOOTER //
// ./src/lib/util/storeUtils.js